const getActiveConsentOneTrustIds = () => window?.OnetrustActiveGroups ?? "";

export default getActiveConsentOneTrustIds;
